export default {
    // forgot password
    email_forgot: 'Email',
    repeatPassword: 'Password repeat'
};
